import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AlertTriangle, Gift } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const daysLeft = (iso) => Math.max(0, Math.ceil((new Date(iso).getTime() - Date.now()) / 864e5));

export default function SubscriptionNotice() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (!user || pathname === "/planos") return null;
  const st = user.subscription_status;
  if (st === "payment_due") {
    return (
      <button data-testid="subscription-notice-due" onClick={() => navigate(`/planos?pagar=${user.plan}`)}
        className="w-full mb-4 rounded-2xl border border-amber-500/40 bg-amber-500/10 text-amber-800 dark:text-amber-300 px-4 py-3 text-sm flex items-center gap-2 text-left">
        <AlertTriangle className="w-4 h-4 shrink-0" />
        <span className="flex-1">Seu plano/teste venceu. Renove em até <b>{daysLeft(user.grace_ends_at)} dia(s)</b> para manter seu perfil.</span>
        <span className="font-semibold underline shrink-0">Pagar agora</span>
      </button>
    );
  }
  if (st === "trialing" && user.trial_ends_at && daysLeft(user.trial_ends_at) <= 5) {
    return (
      <button data-testid="subscription-notice-trial" onClick={() => navigate("/planos")}
        className="w-full mb-4 rounded-2xl border border-emerald-500/30 bg-emerald-500/10 text-emerald-800 dark:text-emerald-300 px-4 py-3 text-sm flex items-center gap-2 text-left">
        <Gift className="w-4 h-4 shrink-0" />
        <span className="flex-1">Faltam <b>{daysLeft(user.trial_ends_at)} dia(s)</b> do seu teste grátis.</span>
        <span className="font-semibold underline shrink-0">Ver plano</span>
      </button>
    );
  }
  return null;
}
